const dateFormat = 'DD.MM.YYYY';

export default dateFormat;
